// extracted by mini-css-extract-plugin
module.exports = {"social":"social-links-module--social--3cTAK","social__list":"social-links-module--social__list--3suKM","social__list__item":"social-links-module--social__list__item--2DCGk"};